import { useEffect } from "react";
import { APP_LINK_REQUEST_RESET_PASSWORD } from "../../CONSTANTS";
import {useSearchParams} from "react-router-dom";
import { isMobile } from "../../Utils";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(()=> {
    if (isMobile()){
      window.location.href = `${APP_LINK_REQUEST_RESET_PASSWORD}${token}`;
      return null;
    }
  }, [token])
  return null;
}

export default ResetPassword;
